import { prefix } from '../../utils/prefix';

const Url = {
  getInfo: `${prefix}/info/personalInfo/get`,
  saveDraft: `${prefix}/draft/personalInfo/save`,
  save: `${prefix}/info/personalInfo/save`,
  upload: `${prefix}/attachment/upload`,
  ocrUploadFront: `${prefix}/attachment/ocrUpLoad/11`, // 上传身份证正面照
  ocrUploadBack: `${prefix}/attachment/ocrUpLoad/12`, // 上传身份证背面
  getIDType: `${prefix}/dataset/IDType`, // 获取证件类型
  getNationality: `${prefix}/dataset/nationality`, // 获取国籍
  getNation: `${prefix}/dataset/nation`, // 获取民族(与国籍有联动)
  getProvince: `${prefix}/dataset/province`, // 获取省份(与国籍有联动)
  getCity: `${prefix}/dataset/city`, // 获取城市(与国籍有联动)
  getRegisterType: `${prefix}/dataset/registerType`, // 获取户口类型
  getPolitical: `${prefix}/dataset/political`, // 获取政治面貌
  getWedStatus: `${prefix}/dataset/wedStatus`, // 获取婚姻状态
  getAreaList: `${prefix}/dataset/get/areaList`, // 获取国家编号
  positionSimpleInfo: `${prefix}/info/positionSimpleInfo`,
  getRelation: `${prefix}/dataset/familyRelation`, // 获取关系
  getPhone: `${prefix}/info/basicInfo/get`, // 通过获取基本信息接口获取手机号
  computerTypes: `${prefix}/info/computerTypes`, // 电脑型号下拉
  getEntryTypeAndComputer: `${prefix}/info/getEntryTypeAndComputer`, // 获取入职类型与电脑类型
  getSignStatus: `${prefix}/sign/getProtocolSignStatus`, // 获取补贴协议签署状态
  createProtocol: `${prefix}/sign/createProtocol`, // 生成补贴笔记本申请协议
  disableProtocol: `${prefix}/sign/disableProtocol`, // 作废笔记本申请协议
  /** 查询办公电脑是否符合当前JF/JG */
  getComputerType: `${prefix}/info/computerType/matching`,
  email: `${prefix}/info/email/postfix`, // 获取公司邮箱
};

export default Url;
